import React from 'react';
import { HStack, Badge, Tooltip, Text } from '@chakra-ui/react';
import {
  ThumbsUp, ThumbsDown, Database, FileText, Presentation, Music, Image as ImageIcon,
  Globe, Video, Code, FolderOpen,
} from 'lucide-react';

// Icon and colour for each resource type key from /resources/options
export const resourceTypeStyles = {
  dataset: { icon: Database, color: 'blue' },
  document: { icon: FileText, color: 'orange' },
  presentation: { icon: Presentation, color: 'yellow' },
  audio: { icon: Music, color: 'pink' },
  image: { icon: ImageIcon, color: 'cyan' },
  website: { icon: Globe, color: 'teal' },
  video: { icon: Video, color: 'red' },
  code: { icon: Code, color: 'purple' },
};

export const typeStyle = (key) => resourceTypeStyles[key] || { icon: FolderOpen, color: 'gray' };

export const statusColors = { pending: 'yellow', published: 'green', rejected: 'red' };
export const statusLabels = { pending: 'Awaiting endorsement', published: 'Published', rejected: 'Not endorsed' };

/**
 * Endorse / not-endorse counts, like an upvote and downvote tally.
 */
export const EndorsementCounts = ({ resource, size = 'sm' }) => {
  const iconSize = size === 'sm' ? 14 : 18;
  const fontSize = size === 'sm' ? 'sm' : 'lg';
  return (
    <HStack spacing={3}>
      <Tooltip label="Experts who endorse">
        <HStack spacing={1} color="green.500">
          <ThumbsUp size={iconSize} />
          <Text fontSize={fontSize} fontWeight="bold">{resource.endorse_count || 0}</Text>
        </HStack>
      </Tooltip>
      <Tooltip label="Experts who do not endorse">
        <HStack spacing={1} color="red.500">
          <ThumbsDown size={iconSize} />
          <Text fontSize={fontSize} fontWeight="bold">{resource.not_endorse_count || 0}</Text>
        </HStack>
      </Tooltip>
    </HStack>
  );
};

export const StatusBadge = ({ status }) => (
  <Badge colorScheme={statusColors[status] || 'gray'} variant="subtle" borderRadius="md" px={2}>
    {statusLabels[status] || status}
  </Badge>
);
